module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_upward.eb3d47eb.png";